const { NODE_ENV } = process.env;
const { hostname } = window.location;

const servers = {
  local: "http://localhost:3017",
  customDev: "https://react.customdev.solutions:3017",
  live: "https://luxuryccs.com:3017",
};

var URL;
if (NODE_ENV === "production" && hostname === "react.customdev.solutions")
  URL = servers.customDev;
else if (NODE_ENV === "production" && hostname.includes("luxuryccs.com"))
  URL = servers.customDev;
else URL = servers.local;

export const SOCKET_URL = `${URL}`;

export const UPLOADS_URL = URL + "/Uploads/";
export const BASE_URL = URL + "/api";

export const SITE_NAME = "My Website";
export const countries = ["USA", "Canada", "UK"];

export const AUTH = {
  login: "/auth/signin",
};
export const USER_AUTH = {
  login: "/user/login",
  signup: "/user/signup",
  getUser: "/user/getUser/",
};
export const USER = {
  getUser: "/user/getUser/",
  guestSignup: "/user/guestSignup",
  guestLogin: "/user/guestLogin",
  verifyGuestAccount: "/user/verifyGuestAccount",
};

export const PROFILE = {
  getMyProfile: "/user/getMyProfile",
  createProfile: "/user/createProfile",
  updateMyProfile: "/user/updateAccount",
};
export const JOB = {
  getCompanyJobs: "/company/career/getAllJobs/",
  getJob: "/company/career/getJob/",
  addJob: "/company/career/addJob",
  getMyJobs: "/company/career/getMyJobs",
  updateJob: "/company/career/updateJob/",
  deleteJob: "/company/career/deleteJob/",
};
export const JUMP = {
  getMyJumps: "/jump/getMyJumps",
  getJump: "/jump/getJump/",
  getLatestJump: "/jump/getLatestJump/",
  getCompanyJumps: "/jump/getCompanyJumps",
};
export const BOOKING = {
  getbooking: "/booking/getBooking/",
  getAllBookings: "/booking/getAllBookings",
  getServicesRates: "/booking/getServicesRates/",
  bookChauffeur: "/booking/bookChauffeur",
  getUserOngoingBooking: "/booking/getUserOngoingBooking",
  getMyBookings: "/booking/getMyBookings",
};
export const EVENT = {
  getupcomingevents: "/company/event/getUpcomingEvents",
  getevent: "/company/event/getEvent/",
  addEvent: "/company/event/addEvent",
  updateEvent: "/company/event/updateEvent/",
  deleteEvent: "/company/event/deleteEvent/",
};

export const PRODUCT = {
  getVendorProducts: "/product/getAllVendorProducts",
  getProduct: "/product/getProduct/",
  getAdminProducts: "/product/getAllAdminProducts",
};
export const RATING = {
  giveRating: "/rating/giveRating",
  getRating: "/rating/getRating/",
  getChauffeurRatings: "/rating/getChauffeurRatings/",
  getUserRatings: "/rating/getUserRatings/",
};
export const PLAN = {
  getPlans: "/plan/getPlans",
};
export const RESET = {
  sendCode: "/reset/sendVerificationCode",
  verifyCode: "/reset/verifyRecoverCode",
  resetPassword: "/reset/resetPassword",
  changePassword: "/reset/changePassword",
};
export const COUPON = {
  getCoupons: "/coupon/getCoupons",
  getCoupon: "/coupon/getCoupon/",
};
export const GIFT = {
  addGift: "/gift/addGift",
  utilizeGift: "/gift/utilizeGift",
};
export const ORDER = {
  getMyOrders: "/order/getMyOrders",
  getOrder: "/order/getOrder/",
};
export const STAY = {
  getAllRooms: "/stay/getAllRooms",
  getRoom: "/stay/getRoom/",
};
export const PAYMENT = {
  paymentConfig: "/payment/config",
  paymentIntent: "/payment/create-payment-intent",
  savePayment: "/payment/savePayment",
  getAllBookingPayments: "/payment/getAllBookingPayments",
  getAllSubscriptionPayments: "/payment/getAllSubscriptionPayments",
  getClientPaymentMetods: "/payment/getClientPaymentMetods",
  createTransaction : '/payment/create-transaction',
  getPaymentProfiles : '/payment/getPaymentProfiles',
  createTransactionWithSavedCard:"/payment/createTransactionWithSavedCard"
};
export const FEEDBACK = {
  addFeedback: "/feedback/addFeedback",
};
export const AVAILABILITY = {
  setHours: "/availabilty/setHours",
  getMyAvailability: "/availabilty/getMyAvailability",
  deleteHours: "/availabilty/deleteHours/",
};
export const DRIVER = {
  signup: "/driver/signup",
  login: "/driver/login",
  updateMyProfile: "/driver/updateMyProfile",
  getDriverVehicle: "/driver/getDriverVehicle/",
  registerVehicle: "/driver/registerVehicle",
  editVehicle: "/driver/editVehicle/",
  toggleActivity: "/driver/toggleActivity",
  acceptRide: "/driver/acceptRide/",
};
export const RIDE = {
  changeRideStatus: "/ride/changeRideStatus/",
  // getUpcomingOrCompletedRides: "/ride/getUpcomingOrCompletedRides",
  // getDriverOngoingRide: "/ride/getDriverOngoingRide",
  getNearbyCars: "/ride/getNearbyCars",
  bookRide: "/ride/bookRide",
  getUserOngoingRide: "/ride/getUserOngoingRide",
};
export const NOTIFICATIONS = {
  getAllMyNotifications: "/notification/getAllMyNotifications",
  toggleNotification: "/notification/toggleNotification/",
};
export const SUBSCRIPTION = {
  buySubscription: "/subscription/buySubscription",
  fetchMySubscriptions: "/subscription/fetchMySubscriptions",
  fetchActiveSubscription: "/subscription/fetchActiveSubscription",
  getSubscription: "/subscription/getSubscription/",
  cancelSubscription: "/subscription/cancelSubscription/",
  calculateSubscriptionAmount : "/subscription/calculateSubscriptionAmount"
};
export const CHAT = {
  createChat: "/chat/createChat",
  fetchMyChats: "/chat/fetchMyChats",
};
export const MESSAGE = {
  createMessage: "/message/createMessage",
  getChatMessages: "/message/getChatMessages/",
};
export const FARE = {
  getAllLatestFares: "/fare/getAllLatestFares",
};
export const PRICING = {
  getPricing: "/pricing/getPricing",
};
export const RATE = {
  getChauffeurRatings: "/rating/getChauffeurRatings/",
};
export const RATES = {
  getAllLatestRates: "/rate/getAllLatestRates",
  getAllRates : "/rate/getAllRates",
};
export const RUSH = {
  getTotalRushHours: "/rushHours/getTotalRushHours",
};
export const GOOGLE_MAPS = "AIzaSyBXqV9bSEkfm5Wh7OQMj37V-n3F4AiyE40";
// export const GOOGLE_MAPS = 'AIzaSyBECY2aNK5YkXshm_ZEqtZY0M_hcJT65Iw'
